import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * Poseidon Agent Memoryのフォームのベースです。
 * NOTE: Chakra の Input は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const PoseidonAgentMemoryFormBase: FC<Props> = ({ register }) => (
  <Input
    id="poseidonAgentMemory"
    type="text"
    placeholder="例: 141Mi"
    {...register('poseidonAgentMemory', {
      required: {
        value: true,
        message: 'Poseidon Agent Memoryは必須です。',
      },
      maxLength: {
        value: 50,
        message: 'Poseidon Agent Memoryは 50 文字以内にする必要があります。',
      },
    })}
  />
);
